import { render, staticRenderFns } from "./prescription-select.vue?vue&type=template&id=53220f3c&scoped=true"
import script from "./prescription-select.vue?vue&type=script&lang=ts"
export * from "./prescription-select.vue?vue&type=script&lang=ts"
import style0 from "./prescription-select.vue?vue&type=style&index=0&id=53220f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53220f3c",
  null
  
)

export default component.exports